import { URLS } from '../config/app-config';
import {secureFetch} from "./secureFetch";

const apiBase = `${URLS.apiBase}/user`;

/**
 * Fetch all collections for the current user.
 * @param {string} token — Bearer token
 * @returns {Promise<Array<{ name: string }>>}
 */
export async function fetchLists(token) {
    const res = await secureFetch(`${apiBase}/lists`, {}, true)
    if (!res.ok) {
        throw new Error(`Failed to fetch lists (status ${res.status})`)
    }
    return res.json()
}

/**
 * Add an article to an existing collection.
 * @param {string} listName
 * @param {{ articleId: string, version: string, language: string, product: string }} payload
 * @param {string} token
 */
export async function addToList(listName, payload, token) {
    const res = await secureFetch(
        `${apiBase}/lists/${encodeURIComponent(listName)}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                article_id: payload.articleId,
                version: payload.version,
                language: payload.language,
                product: payload.product,
            }),
        }, true
    )
    if (!res.ok) {
        const err = new Error(`Add to list failed (status ${res.status})`)
        err.status = res.status
        throw err
    }
    return res
}

/**
 * Create a new collection.
 * @param {string} name
 * @param {string} token
 */
export async function createList(name, token) {
    const res = await secureFetch(`${apiBase}/lists`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name }),
    }, true)
    if (!res.ok) {
        throw new Error(`Create list failed (status ${res.status})`)
    }
    return res
}

/**
 * Create a new collection and immediately add the article to it.
 * @param {string} name
 * @param {{ articleId: string, version: string, language: string, product: string }} payload
 * @param {string} token
 */
export async function createListAndAdd(name, payload, token) {
    // First create the list
    await createList(name, token)
    // Then add the article
    return addToList(name, payload, token)
}

